import React from "react";
import { Box, Divider } from "@mui/material";
import { GlobalTabCollection, StyledTab } from "../styles";
import GeneralAdminMenu from "./General/GeneralAdminMenu";
import AnalyticalAdminMenu from "./Analytical/AnalyticalAdminMenu";
import BlendingAdminMenu from "./Blending/BlendingAdminMenu";
import InventorySDSAdminMenu from "./Inventory/InventoryAdminMenu";
import STMasterData from "./StationaryTesting/STMasterData";
import DistillationMasterData from "./DistillationMasterData";
import StockroomMasterData from "./StockroomMasterData";
import Notifications from "./Notifications";
import WorkRequestAdminMenu from "./WorkRequest/WorkRequestAdminMenu";

const Admin = ({ ...props }) => {
  const canAccessGeneral = true;
  const canAccessSDS = true;
  const canAccessAnalytical = true;
  const canAccessBlending = true;
  const canAccessWorkRequest = true;
  const canAccessST = true;
  const canAccessDistillation = true;
  const canAccessStockroom = true;
  const canAccessNotification = true;

  const [tabValue, setTabValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <GeneralAdminMenu />;
      }
      case 1: {
        return <InventorySDSAdminMenu />;
      }
      case 2: {
        return <AnalyticalAdminMenu />;
      }
      case 3: {
        return <BlendingAdminMenu />;
      }
      case 4: {
        return <WorkRequestAdminMenu />;
      }
      case 5: {
        return <STMasterData />;
      }
      case 6: {
        return <DistillationMasterData />;
      }
      case 7: {
        return <StockroomMasterData />;
      }
      case 8: {
        return <Notifications />;
      }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <Box paddingBottom={4}>
      <span className="pageheader">Site Administration</span>
      <Divider className="dividerbar" />
      <div>
        <Box sx={{ bgcolor: "#fff", pt: 3, pb: 1 }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label="ant example">
            <StyledTab disabled={!canAccessGeneral} label="General Site Master Data" />
            <StyledTab disabled={!canAccessSDS} label="SDS Master Data" />
            <StyledTab disabled={!canAccessAnalytical} label="Analytical Master Data" />
            <StyledTab disabled={!canAccessBlending} label="Blending Master Data" />
            <StyledTab disabled={!canAccessWorkRequest} label="Work Request Master Data" />
            <StyledTab disabled={!canAccessST} label="Stationary Testing Master Data" />
            <StyledTab disabled={!canAccessDistillation} label="Distillations Master Data" />
            <StyledTab disabled={!canAccessStockroom} label="Stockroom Master Data" />
            <StyledTab disabled={!canAccessNotification} label="Notifications" />
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </Box>
  );
};

export default Admin;
